import { http } from "../app/services/apiService/apiService";

export async function getSingleRoute(pageType){
    let res  = await http.get(`/cms/legacy-routing/get-slug/?page_type=${pageType}`)
    return '/'+res.data.slug
}